import {Component} from '@angular/core';
import { Meta } from "@angular/platform-browser";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private meta: Meta) {
    this.meta.addTag({ name: 'og:site_name', content: window.location.hostname });
    this.meta.addTag({ name: 'twitter:domain', content: window.location.hostname });
    this.meta.addTag({ name: 'twitter:site', content: window.location.hostname });
  }
}
